import { A9Service, AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import { MembershipAdd, MembershipUpdate, RsMembership, RsMembershipInfo } from './types';

export type ICustomerMembershipHistoryDataProvider = IDataProviderV2<RsMembership, RsMembershipInfo, MembershipAdd, MembershipUpdate>;

@A9Service('customerMembershipHistoryDataProvider')
export class CustomerMembershipHistoryDataProvider
    extends AbstractDataProviderV2<RsMembership, RsMembershipInfo, MembershipAdd, MembershipUpdate>
    implements ICustomerMembershipHistoryDataProvider
{
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/memberships');
    }

    public patch(): Promise<never> {
        return Promise.reject('method is not supported');
    }
}
